module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', _vm._b({}, 'el-col', _vm.$props), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4adf6522"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ci-components/components/col.vue
// module id = 253
// module chunks = 4